import React from 'react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Globe2, Lock, Tags, BookOpen } from 'lucide-react'

interface PublishSettingsProps {
  onPublish: () => void
  onSaveDraft: () => void
}

const PublishSettings = ({ onPublish, onSaveDraft }: PublishSettingsProps) => {
  const [title, setTitle] = React.useState('')
  const [tags, setTags] = React.useState('')
  const [isPublic, setIsPublic] = React.useState(true)

  return (
    <div className="w-full">
      <Card className="p-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl font-bold text-gray-800 mb-2">发布设置</h2>
          <p className="text-sm text-gray-500 mb-8">
            完善绘本信息，让更多人发现你的作品。
          </p>

          <div className="space-y-6">
            <div className="space-y-3">
              <label className="block text-sm font-medium text-gray-700">
                绘本标题
              </label>
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="给你的绘本起个名字"
                className="w-full"
              />
            </div>

            <div className="space-y-3">
              <label className="block text-sm font-medium text-gray-700">
                标签
              </label>
              <Input
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                placeholder="添加标签，用逗号分隔（如：童话,冒险,动物）"
                className="w-full"
              />
            </div>

            <div className="space-y-3">
              <label className="block text-sm font-medium text-gray-700">
                可见性
              </label>
              <div className="flex gap-4">
                <Button
                  type="button"
                  variant={isPublic ? 'default' : 'outline'}
                  className={`flex items-center gap-2 flex-1 transition-colors ${
                    isPublic 
                      ? 'bg-primary/10 text-primary hover:bg-primary/20' 
                      : 'hover:bg-gray-50'
                  }`}
                  onClick={() => setIsPublic(true)}
                >
                  <Globe2 className="w-4 h-4" />
                  <span>公开</span>
                </Button>
                <Button
                  type="button"
                  variant={!isPublic ? 'default' : 'outline'}
                  className={`flex items-center gap-2 flex-1 transition-colors ${
                    !isPublic 
                      ? 'bg-primary/10 text-primary hover:bg-primary/20' 
                      : 'hover:bg-gray-50'
                  }`}
                  onClick={() => setIsPublic(false)}
                >
                  <Lock className="w-4 h-4" />
                  <span>私密</span>
                </Button>
              </div>
              <p className="text-xs text-gray-500">
                {isPublic ? '所有人都可以看到这个绘本' : '只有你自己可以看到这个绘本'}
              </p>
            </div>
          </div>

          <div className="flex justify-end items-center mt-10 gap-3">
            <Button
              variant="outline"
              onClick={onSaveDraft}
              className="flex items-center gap-2"
            >
              <BookOpen className="w-4 h-4" />
              <span>保存草稿</span>
            </Button>
            <Button
              onClick={onPublish}
              disabled={!title}
              className="flex items-center gap-2 bg-gradient-to-r from-primary via-accent to-secondary hover:opacity-90"
            >
              <Tags className="w-4 h-4" />
              <span>立即发布</span>
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default PublishSettings 